import { createFileRoute } from "@tanstack/react-router";
import { CorporateHomeContent } from "@/components/home/CorporateHomeContent";
import { SiteShell } from "@/components/site/SiteShell";
import { MexicoMarketSignal } from "@/components/site/MexicoMarketSignal";
import { alternatePath } from "@/lib/i18n";
import {
  breadcrumbJsonLd,
  faqJsonLd,
  webPageJsonLd,
} from "@/lib/seo";
import {
  buildCorporateHead,
  corporateProfessionalServiceJsonLd,
} from "@/lib/corporate-seo";
import { publicProjectsQuery, siteSettingsQuery } from "@/lib/query-registry";
import { HOME_FAQS } from "@/components/home/home-faqs";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/es/")({
  head: () => {
    const path = "/es";
    return buildCorporateHead({
      locale: "es",
      title: "Agencia Shopify en México para Marcas DTC y B2B | Shugert",
      description:
        "Agencia Shopify en México para marcas DTC y B2B establecidas: desarrollo, Shopify Plus, migraciones, SEO técnico, CRO, rendimiento e integraciones con ingeniería senior.",
      path,
      altPath: alternatePath(path, "en"),
      ogImage: "/og-default-v2.jpg",
      jsonLd: [
        corporateProfessionalServiceJsonLd("es"),
        breadcrumbJsonLd([{ name: "Inicio", path: "/es" }]),
        faqJsonLd(HOME_FAQS.es),
        webPageJsonLd({
          name: "Agencia Shopify en México para Marcas DTC y B2B",
          path: "/es",
          description:
            "Shugert es una agencia Shopify para equipos en México y Latinoamérica que necesitan desarrollo, Shopify Plus, migraciones, SEO técnico, CRO, rendimiento e integraciones con ownership de ingeniería senior.",
          inLanguage: "es-MX",
        }),
      ],
    });
  },
  loader: async ({ context }) => {
    await setEdgeHtmlCache();
    const [{ projects }, { settings }] = await Promise.all([
      context.queryClient.ensureQueryData(publicProjectsQuery()),
      context.queryClient.ensureQueryData(siteSettingsQuery()),
    ]);
    return { projects, homeLimit: settings.home_projects_limit };
  },
  component: EsHomeRoute,
});

function EsHomeRoute() {
  const { projects, homeLimit } = Route.useLoaderData();
  return (
    <SiteShell>
      <div className="home-money-palette">
        <CorporateHomeContent projects={projects as any} homeLimit={homeLimit} />
        <MexicoMarketSignal
          title="Agencia Shopify para equipos en México que necesitan ejecución senior, no otra capa de coordinación."
          body="Shugert trabaja con marcas DTC y B2B en México y Latinoamérica en desarrollo Shopify, Shopify Plus, migraciones, SEO técnico, CRO, rendimiento e integraciones. Cada servicio conserva su propia página comercial para que Google y los compradores encuentren el alcance correcto sin mezclar intenciones."
          links={[
            { label: "Servicios Shopify en México", href: "/es/servicios" },
            { label: "Desarrollo Shopify", href: "/es/desarrollo-shopify" },
            { label: "Agencia Shopify Plus", href: "/es/agencia-shopify-plus" },
            { label: "Migración a Shopify", href: "/es/migracion-shopify" },
          ]}
        />
      </div>
    </SiteShell>
  );
}
